<template>
	<div>
		<tag :text="text" icon="/images/icons/product-giveaways.svg" />
	</div>
</template>

<script>
import { casePromo } from "@u/helpers";
import Tag from "./tag";

export default {
	name: "HolidayTag",
	components: {
		Tag
	},
	props: {
		build: {
			type: [Object, Array],
			default() {
				return {};
			}
		}
	},
	computed: {
		text() {
			return casePromo(this.build) ? "It’s on us!" : "Reduced Price";
		}
	}
};
</script>
